const AGENT_ROLES = new Set(['agent', 'independent_agent', 'agency_agent']);

/** Navigation state for /property/:id so Back returns to the caller screen. */
export function buildPropertyNavState(fromPath, fromLabel, extra = {}) {
    return {
        from: fromPath,
        fromLabel: fromLabel || 'Back',
        ...extra,
    };
}

/** Build property nav state from the current React Router location. */
export function propertyNavStateFromLocation(location, fromLabel, extra = {}) {
    const from = `${location?.pathname || ''}${location?.search || ''}` || '/';
    return buildPropertyNavState(from, fromLabel, extra);
}

/** Fallback when no explicit from and history back is unavailable. */
export function defaultPropertyBackPath(user) {
    const role = String(user?.role || '').toLowerCase();
    if (AGENT_ROLES.has(role)) return '/agent-dashboard';
    if (role === 'agency') return '/dashboard';
    return '/listing-management';
}

/** Hybrid Back: explicit from → history -1 → role default. */
export function handlePropertyBack(navigate, { from, user } = {}) {
    if (from && typeof from === 'string') {
        navigate(from);
        return;
    }
    if (typeof window !== 'undefined' && window.history.length > 1) {
        navigate(-1);
        return;
    }
    navigate(defaultPropertyBackPath(user));
}
